const STATUS_BADGE_CONFIG = {
  pending: { textKey: "pending", color: "bg-yellow-100 text-yellow-800" },
  pending_quote: { textKey: "pendingQuoteStatus", color: "bg-blue-100 text-blue-800" },
  pending_approval: { textKey: "needsApproval", color: "bg-orange-100 text-orange-800" },
  quoted: { textKey: "quoted", color: "bg-purple-100 text-purple-800" },
  confirmed: { textKey: "confirmed", color: "bg-green-100 text-green-800" },
  completed: { textKey: "completed", color: "bg-surface text-foreground" },
  cancelled: { textKey: "cancelled", color: "bg-red-100 text-red-800" },
};

export default function SupplierStatusBadge({ status, t }) {
  const badge = STATUS_BADGE_CONFIG[status] || {
    textKey: "status",
    color: "bg-surface text-foreground",
  };

  return (
    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${badge.color}`}>
      {t(badge.textKey)}
    </span>
  );
}
